import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

/** Where a card's three-dot menu was opened - see CardActionMenuComponent's `canRemove`. */
export interface CardMenuOpenedEvent {
  /** The menu offers REMOVE (take the card out of the Plan) - i.e. it belongs to a Plan being edited. */
  inPlan: boolean;
}

/**
 * FLIP-386. Tells the Plan contextual onboarding lessons that a card's three-dot menu opened or
 * closed - CA01/CA02 (Plan cards) and DM04 (Deck Manager cards) complete on the real menu opening,
 * and CA02's explanation must go when the menu does. The menu component is shared by every card in
 * the app, so it reports here rather than each surface wiring its own output up the card tree.
 * The lessons decide what an event means from the route and `inPlan`.
 */
@Injectable({ providedIn: "root" })
export class CardMenuSignalService {
  private readonly openedSub = new Subject<CardMenuOpenedEvent>();
  private readonly closedSub = new Subject<void>();
  private readonly selectedSub = new Subject<string>();

  readonly opened$: Observable<CardMenuOpenedEvent> = this.openedSub.asObservable();
  readonly closed$: Observable<void> = this.closedSub.asObservable();
  /** A menu row was selected (just before the menu closes) - CA02A-E complete on their own row. */
  readonly selected$: Observable<string> = this.selectedSub.asObservable();

  notifyOpened(event: CardMenuOpenedEvent): void {
    this.openedSub.next(event);
  }

  notifySelected(action: string): void {
    this.selectedSub.next(action);
  }

  notifyClosed(): void {
    this.closedSub.next();
  }
}
